<div ngModelGroup="comboUnidade-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-pesquisavel #comboUnidade
                       nome="unidade-{{data}}"
                       [itens]="dados"
                       itemDescricao="nomeUnidade"
                       itemId="idUnidade"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Nome da unidade"
                       label="Unidade"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
